import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import { Brand } from "../Entity/Product";

export async function getBrandBySlugRep(locale: string,brandName: string): Promise<Brand> {
  try {
    const response = await axios.get<Brand>(
      `${BASE_API_URL}/${locale}/brand/${brandName}`
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}
